import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postDriverAvatarRequest } from '../../services/DriversService';
import { Driver, PostDriverAvatarRequest } from '../../types/Drivers';

type Result = UseMutationResult<Driver, Error, PostDriverAvatarRequest>;

function usePostDriverAvatarRequest(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postDriverAvatarRequest, {
    onSuccess: () => {
      successCb();
      // queryClient.invalidateQueries({ queryKey: ['driver'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostDriverAvatarRequest;
